import React from 'react';
import classnames from 'classnames';
import CommentIcon from '../../../../../Icons/Comment';
import { getDeviationUrl, getDeviationResourceType, } from '../../../../_helpers';
import OverlayControl from './OverlayControl';
import BiLink from '../../../../../biLogger/Components/BiLink';
import { BiEventType } from '../../../../../biLogger/constants';
import s from '../Overlay.scss';
var CommentControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, iconType = _a.iconType, iconClassName = _a.iconClassName;
    return (React.createElement(OverlayControl, { className: className, stat: deviation.stats && deviation.stats.comments, title: "comments", iconType: iconType },
        React.createElement(BiLink, { className: classnames(s['icon-button']), href: getDeviationUrl(deviation) + "#comments", biData: {
                evid: BiEventType.THUMB_CLICK_COMMENT,
                typeid: getDeviationResourceType(deviation),
                creatorid: deviation.author ? deviation.author.useridUuid : undefined,
                itemid: deviation.deviationId,
            } },
            React.createElement(CommentIcon, { className: classnames(s['icon'], iconClassName) }))));
};
CommentControl.displayName = 'CommentControl';
export default CommentControl;
//# sourceMappingURL=Comment.js.map